// client/src/components/RequireAdmin.jsx
import { Navigate } from "react-router-dom";

export default function RequireAdmin({ children }) {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (!token) return <Navigate to="/login" />;

  if (user.role !== "admin" && user.role !== "superadmin") {
    return <Navigate to="/student" />;
  }

  return children;
}
